import { createContext } from "react";

import { useTheme } from "./useTheme";

type ThemeContextType = ReturnType<typeof useTheme>;

export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined,
);
